import Image from '@base/Image';
import ImageCarousel from '@comp/ImageCarousel/ImageCarousel';
import { Spacings, mediaQuery } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  .scholarship-full-view-carousel {
    position: absolute;
    bottom: ${Spacings.SPACING_6B};
    margin-top: 0;
    z-index: 1;
  }
`;

const Banner = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1136 / 340;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  img {
    object-fit: contain;
    object-position: center;
  }
  ${mediaQuery.uptoTablet} {
    aspect-ratio: 318 / 113;
  }
`;

const FullViewCarousel = ({ carousel, onClick }) => {
  const isMobile = useIsMobile();

  return (
    <Wrapper>
      <ImageCarousel
        color="var(--color-base-1)"
        className="scholarship-full-view-carousel"
      >
        {carousel.map((banner, index) => (
          <Banner
            key={`full-view-banner-${banner.id}`}
            $isClickable
            onClick={onClick}
          >
            <Image
              priority
              src={
                isMobile
                  ? banner.mwImage || banner.webImage
                  : banner.webImage || banner.mwImage
              }
              alt={`banner-${index}`}
              layout="fill"
            />
          </Banner>
        ))}
      </ImageCarousel>
    </Wrapper>
  );
};

export default FullViewCarousel;
